//import 数据 from ''	这里面可以获取数据
import * as types from './type'

export default{

	/*头部信息*/
	//commit中提交的事件名称， 统一触发types下的事件名

	/*loading*/
	hideLoading:({commit})=>{
		commit(types.HIDE_LOADING)
	},
	showLoading:({commit})=>{
		commit(types.SHOW_LOADING)
	},
    //toast 展示
    hideToast:({commit})=>{
        commit(types.HIDE_TOAST)
    },
    showToast:({commit})=>{
        commit(types.SHOW_TOAST)
    },

}



// WEBPACK FOOTER //
// ./src/store/actions.js